// AUTO-GENERATED from URA waterbody and MP2025 rail-line GeoJSON.
// Coordinates use the same 1000 x 630.7 viewBox as singaporeMapData.ts.

export const WATERBODY_PATHS: string[] = [
  "M245.9 262.0L242.4 262.1L240.7 265.9L243.7 268.7L247.8 268.3L252.4 272.2L251.8 274.5L252.9 274.6L254.7 270.9L257.4 269.7L260.6 271.9L257.8 264.7L254.9 263.7L250.5 264.7L245.9 262.0Z",
  "M151.1 124.1L149.4 125.1L151.7 129.5L151.3 132.3L149.5 133.1L148.0 131.8L147.0 133.3L143.4 130.8L142.0 128.2L139.5 127.2L135.6 130.9L136.2 132.4L130.4 137.6L130.5 139.5L132.6 140.2L131.8 141.6L133.6 143.4L133.4 146.3L135.7 145.6L133.9 149.5L134.0 152.2L134.7 152.6L137.0 149.4L138.5 149.5L137.9 152.8L138.9 154.6L136.8 154.5L137.2 159.1L133.9 162.4L135.1 166.0L137.0 165.3L136.3 164.1L137.4 162.6L141.2 162.4L140.0 159.5L141.4 157.3L145.0 162.2L143.8 164.7L141.6 164.5L142.7 166.1L145.1 166.4L146.7 164.4L149.5 166.5L151.7 166.3L149.8 162.1L147.7 161.1L148.5 158.1L146.2 155.5L147.7 154.5L151.5 156.1L150.2 152.0L152.9 150.5L150.1 144.1L147.3 145.3L145.7 141.0L146.6 140.2L147.7 141.8L152.7 142.0L152.1 137.3L153.0 134.6L153.5 138.1L156.8 136.5L158.9 139.5L160.8 133.8L157.8 134.4L160.4 133.1L159.7 131.4L154.8 132.0L152.9 125.5L151.3 125.5L151.1 124.1Z",
  "M576.3 109.1L582.9 99.6L581.4 98.7L574.2 109.8L565.0 107.2L562.9 110.4L564.0 110.9L564.7 109.9L564.8 111.7L566.1 111.0L565.3 112.1L569.6 114.8L573.1 111.8L578.1 111.9L584.4 115.5L594.4 117.8L595.2 115.3L586.1 114.1L581.4 111.4L575.9 110.1L576.3 109.1Z",
  "M261.4 316.2L263.5 312.4L266.4 300.9L265.4 298.9L263.3 299.4L263.3 303.0L249.6 326.6L253.8 327.3L261.4 316.2Z",
  "M897.1 120.4L900.3 124.0L899.1 125.1L902.3 123.6L901.1 125.2L902.6 124.0L901.6 125.4L902.4 126.2L904.1 124.4L902.9 123.5L904.7 124.3L906.8 121.0L909.6 123.0L909.8 126.1L912.4 123.9L916.8 126.2L918.3 124.5L920.5 125.0L920.8 121.4L915.4 122.2L911.3 119.8L909.1 116.8L911.1 115.9L912.0 111.4L917.2 110.5L923.2 106.5L917.3 105.4L913.8 106.5L912.2 105.3L911.3 106.7L909.7 106.8L908.7 104.4L909.0 97.5L907.8 96.4L908.1 100.5L907.1 102.6L905.0 103.0L906.9 105.3L907.8 111.3L904.7 109.9L901.8 112.9L898.6 106.5L897.6 110.1L899.2 117.1L897.1 120.4Z",
  "M390.5 187.8L390.3 187.1L389.4 187.9L389.3 193.7L383.4 191.7L388.2 197.0L386.5 199.6L383.5 200.2L382.3 199.1L384.3 203.6L383.2 204.8L379.9 203.7L377.2 197.2L376.9 202.2L373.7 202.9L372.6 206.2L373.6 207.7L373.2 213.4L375.1 209.4L377.5 208.8L380.5 210.3L379.8 214.0L378.2 216.2L372.2 218.5L366.8 217.1L368.8 219.7L368.3 220.9L363.1 221.7L366.9 222.8L367.7 224.2L367.5 226.7L364.9 229.4L367.0 228.9L368.2 231.4L369.1 230.9L368.0 228.2L369.4 222.8L370.9 221.4L373.5 221.7L373.4 227.5L374.9 227.4L374.1 225.1L375.9 221.4L378.1 220.6L379.3 221.4L378.7 224.8L382.5 222.7L381.0 219.4L383.2 217.6L384.9 219.3L383.5 215.5L386.3 210.3L387.8 210.9L388.8 215.8L391.1 211.1L393.5 211.9L393.8 213.9L391.9 215.5L394.8 217.5L396.2 215.0L400.0 213.5L401.5 214.3L401.7 215.9L397.7 221.2L394.6 221.4L392.5 219.5L393.1 221.7L395.4 223.4L394.2 225.0L390.2 222.8L389.2 219.3L387.5 222.7L385.0 222.5L379.2 229.3L381.7 228.6L386.6 224.2L389.4 225.2L390.1 226.7L386.6 227.9L388.7 229.1L388.5 230.0L380.1 234.0L379.6 235.7L383.3 234.3L385.3 236.0L388.4 236.4L389.2 234.4L392.1 236.8L391.6 233.2L392.7 231.7L393.9 231.4L394.7 233.5L396.2 232.1L395.7 228.4L397.0 228.0L399.4 230.4L399.3 226.4L403.5 227.3L401.6 223.8L402.9 221.9L406.3 222.7L405.9 220.0L408.7 217.0L409.8 217.6L408.7 221.0L404.7 228.1L406.3 228.8L407.1 226.8L408.7 227.0L411.5 233.4L410.8 222.3L411.6 221.7L412.7 223.7L416.0 224.5L417.0 222.4L415.7 219.1L413.9 218.8L415.1 216.2L417.2 217.5L418.9 216.8L418.5 221.2L421.8 219.8L421.7 216.6L423.3 216.9L428.3 223.6L426.4 216.8L428.1 212.1L426.5 209.5L428.8 207.3L427.3 201.8L425.2 200.5L424.6 196.6L420.3 196.7L417.9 200.7L415.7 199.8L414.9 204.7L417.5 205.3L418.3 206.7L412.0 213.0L410.4 211.5L410.4 207.6L409.0 204.7L406.7 209.7L405.2 208.1L402.0 209.1L401.0 208.4L400.9 206.3L403.7 204.2L403.4 203.0L399.1 203.5L398.4 205.8L396.8 206.0L396.6 204.1L400.8 197.1L397.4 199.5L396.0 199.0L396.1 201.3L392.9 203.3L392.2 200.2L389.1 202.9L391.1 195.1L392.2 193.7L394.1 193.7L391.5 192.6L390.5 187.8Z",
  "M664.3 258.9L663.8 257.8L661.5 257.2L651.5 260.3L649.4 263.6L650.5 263.7L650.3 265.5L653.2 270.1L662.8 273.0L667.1 271.1L674.8 273.2L678.0 272.8L677.3 268.7L674.9 266.6L672.8 266.7L670.7 261.6L668.1 261.6L666.4 260.3L664.1 260.9L664.3 258.9Z",
  "M102.6 265.6L99.2 272.6L97.1 265.9L97.9 264.5L80.3 249.4L80.0 246.5L78.2 245.1L73.7 236.4L72.3 236.2L69.4 244.6L85.5 259.7L91.5 260.9L95.4 263.8L96.1 266.1L94.8 271.4L101.6 279.0L103.8 278.7L106.5 275.7L113.4 276.5L116.8 274.3L109.9 274.9L103.7 271.8L100.2 273.8L99.4 272.9L102.6 265.6Z",
  "M522.2 96.2L520.8 95.3L518.8 101.9L514.8 105.9L510.9 106.3L511.2 107.1L512.5 106.0L513.5 107.3L511.2 110.4L510.8 114.0L508.6 116.0L505.6 114.7L500.7 117.7L501.2 119.4L504.8 121.4L505.1 123.5L501.1 125.3L498.9 128.6L495.5 130.1L493.9 129.3L490.9 131.0L483.5 126.9L483.8 123.9L482.7 122.6L483.1 126.0L481.2 127.2L478.5 126.1L476.3 126.8L474.9 123.5L467.3 127.4L465.4 126.4L463.7 128.8L463.6 132.3L461.0 139.5L460.0 140.0L461.0 141.7L463.7 140.9L464.4 137.8L466.9 135.3L474.1 133.1L478.3 134.7L472.8 138.8L472.7 143.0L474.7 143.0L476.0 145.4L473.8 146.5L469.6 154.9L473.5 148.8L478.6 151.5L473.5 157.6L478.7 151.7L483.0 151.6L484.5 154.9L485.3 154.7L483.8 151.4L487.8 148.0L486.5 146.0L488.5 145.5L489.5 142.9L491.6 145.4L495.2 146.8L497.0 145.1L496.2 140.4L498.6 140.6L500.0 137.2L508.7 131.7L512.2 125.9L521.5 119.6L525.4 115.5L526.9 111.8L529.6 110.8L530.1 107.3L533.7 100.9L522.2 96.2Z",
  "M78.4 252.7L69.4 244.6L66.9 253.2L70.8 253.4L72.9 255.3L77.3 256.5L79.6 259.1L79.8 261.4L83.2 264.6L89.1 265.3L91.4 263.6L92.6 265.8L94.1 265.2L94.8 266.8L91.2 270.3L91.7 273.4L93.8 275.5L93.7 277.4L98.9 280.6L101.6 279.2L94.8 271.4L96.1 266.1L95.4 263.8L91.5 260.9L85.5 259.7L78.4 252.7Z",
  "M554.3 389.7L545.5 378.6L540.6 367.3L536.4 367.8L537.3 376.0L535.9 377.6L530.8 377.6L530.6 382.8L540.8 386.7L548.8 391.7L550.7 394.1L555.2 390.8L554.3 389.7Z",
  "M645.6 129.3L654.0 136.9L652.6 139.4L654.3 137.1L657.5 138.8L658.9 137.3L655.4 133.1L650.9 131.0L647.6 127.9L644.2 122.5L641.1 113.3L639.3 113.6L640.5 120.2L645.6 129.3Z",
  "M272.1 66.9L270.6 69.1L274.6 73.2L273.5 75.7L275.4 75.9L275.6 77.2L272.3 80.5L269.5 80.7L275.4 82.5L271.6 93.4L269.4 96.3L270.3 96.5L269.4 99.2L269.8 102.6L255.7 115.3L257.3 115.3L270.1 103.2L270.8 96.9L276.3 82.7L271.2 96.8L270.7 102.8L257.5 115.5L253.7 116.5L252.5 119.4L250.5 118.2L247.4 119.7L248.3 123.7L255.0 122.5L285.1 92.0L284.9 80.8L280.0 67.3L275.2 67.3L273.0 69.2L272.1 66.9Z",
  "M277.4 101.9L276.9 100.5L254.6 122.9L248.3 123.7L248.6 126.7L261.7 124.6L263.2 122.9L261.9 120.8L263.6 117.2L264.8 117.7L267.2 116.6L269.7 113.1L273.2 113.9L274.2 111.3L276.6 110.1L275.6 105.0L276.8 103.6L281.7 117.8L281.4 121.5L282.3 121.7L282.5 117.2L277.4 101.9Z",
  "M501.8 21.2L493.0 26.7L499.5 24.3L497.0 34.9L498.0 45.7L504.8 47.6L515.1 42.6L519.1 43.5L516.7 37.9L509.8 40.4L504.2 44.2L500.4 43.6L499.8 32.8L500.6 31.0L502.4 31.2L503.3 27.0L502.1 23.8L505.0 22.7L501.8 21.2Z",
  "M658.1 241.3L654.2 240.6L651.0 247.6L654.6 255.0L660.8 252.2L664.2 243.6L660.0 241.1L658.1 241.3Z",
  "M621.2 188.1L617.7 187.9L618.9 188.4L619.2 191.2L618.8 197.7L612.6 205.7L608.2 215.7L601.4 222.6L600.8 225.4L602.0 225.3L602.5 223.0L610.0 215.8L614.0 206.6L620.1 199.2L621.9 193.9L621.2 188.1Z",
  "M408.1 114.9L405.0 114.6L403.0 116.6L406.2 115.7L407.8 117.0L406.6 121.0L403.8 121.9L406.3 123.1L406.5 125.3L405.3 126.6L409.5 130.1L409.4 132.4L407.2 134.7L405.2 134.1L404.3 130.8L402.0 132.9L400.4 132.5L401.8 127.1L400.5 124.5L400.6 127.1L397.3 130.7L394.6 130.9L392.2 129.2L391.4 126.8L392.3 125.0L390.7 124.7L390.2 123.3L393.5 117.4L390.4 120.7L388.4 120.6L387.7 124.2L385.8 123.4L384.3 120.2L384.1 126.4L377.8 121.9L379.4 126.0L374.7 124.9L378.1 128.1L378.2 129.5L376.4 130.9L371.0 131.4L374.7 134.0L375.0 136.6L376.2 136.9L375.9 134.8L377.5 132.7L379.2 133.1L379.7 134.7L381.3 130.3L387.5 130.8L387.3 132.3L385.0 132.8L384.2 134.6L387.4 136.1L389.2 133.3L392.6 133.9L394.8 135.4L392.0 138.3L393.3 139.8L397.2 137.9L398.4 139.2L395.7 141.1L395.3 144.0L392.8 142.9L391.0 144.8L388.0 139.8L383.5 138.8L386.2 141.8L386.8 146.1L385.0 147.1L380.9 146.1L380.5 147.1L382.5 148.5L381.5 149.5L375.5 144.7L376.9 141.0L373.8 144.1L372.0 142.5L369.9 143.8L368.3 139.5L367.8 141.7L366.4 142.0L367.9 144.1L365.2 145.3L371.7 145.5L375.3 148.3L376.0 150.5L372.3 149.3L372.4 152.6L366.7 153.0L365.9 150.3L365.0 153.2L363.1 152.2L362.4 153.6L358.6 155.0L356.0 154.4L356.5 155.7L354.6 156.5L362.0 156.3L364.1 155.1L370.9 156.1L369.3 159.1L364.8 161.7L360.8 161.1L356.1 163.3L359.2 163.6L358.8 167.0L361.3 163.4L364.6 164.1L366.0 165.5L364.5 169.8L364.4 176.2L361.7 181.1L363.1 181.4L365.7 176.2L368.7 177.2L366.2 175.2L365.9 172.9L367.6 171.0L368.9 164.8L371.2 162.6L373.8 164.8L375.7 179.3L376.4 175.5L378.0 174.5L375.2 170.7L376.0 168.0L377.5 167.2L375.8 166.0L375.8 163.5L377.9 161.8L375.7 160.6L375.7 158.3L379.7 155.7L382.6 157.4L383.7 153.9L388.9 153.9L391.7 151.0L393.1 152.4L390.2 156.1L391.8 156.9L391.4 160.9L389.3 164.1L386.5 165.6L391.0 166.0L393.3 175.7L393.2 171.1L394.8 169.8L393.3 168.8L392.0 164.5L392.4 162.9L393.5 163.1L392.7 161.7L394.9 157.0L399.5 153.4L401.5 155.6L404.7 155.5L407.1 152.4L409.4 152.1L416.3 143.8L420.4 136.5L417.4 134.8L415.2 127.7L412.6 125.4L410.4 125.4L409.8 122.1L412.3 120.3L409.6 119.4L409.5 115.5L408.1 114.9Z",
  "M287.4 94.6L292.4 87.1L291.0 79.2L283.2 67.1L274.9 66.9L272.9 68.6L272.1 66.8L273.0 69.2L275.2 67.3L280.0 67.3L285.3 83.1L285.1 92.0L276.9 100.5L277.4 101.9L280.4 102.3L287.4 94.6Z",
  "M229.1 117.2L226.2 116.8L224.2 118.9L226.7 117.4L229.9 119.7L228.8 121.4L229.9 123.7L229.9 128.5L234.7 126.3L241.7 125.3L242.8 126.2L241.7 132.3L238.4 135.5L240.1 136.6L245.5 127.4L248.6 126.7L248.3 123.7L233.9 123.7L229.1 117.2Z",
  "M147.6 95.3L151.8 98.0L154.7 102.6L157.0 101.4L161.5 105.4L163.7 104.3L160.4 100.8L159.6 96.4L162.0 96.0L163.8 101.6L165.9 101.9L164.6 98.0L165.2 95.1L164.0 94.2L165.6 91.4L164.9 89.8L169.1 92.9L168.7 98.2L169.1 92.9L172.9 94.2L174.8 97.7L175.7 96.1L174.9 94.3L179.2 97.2L180.2 99.3L183.2 97.1L177.1 92.5L177.7 90.9L180.4 89.8L179.4 87.7L174.3 90.2L171.8 88.0L169.3 89.3L166.1 85.4L165.1 87.4L162.2 87.1L160.1 85.0L155.9 87.6L159.1 91.3L156.5 94.4L154.4 94.7L150.6 90.9L150.6 92.4L148.6 92.5L147.6 95.3Z",
  "M141.1 188.4L140.3 180.6L134.2 180.7L132.8 179.5L129.2 181.3L123.1 180.8L122.6 172.5L122.0 183.1L119.5 184.4L116.7 182.9L114.8 183.9L110.4 180.1L99.7 199.4L101.6 204.3L99.2 206.8L97.7 206.0L97.2 208.6L94.7 208.5L91.1 206.0L78.9 229.8L72.7 235.6L75.0 235.9L76.3 237.7L76.3 235.4L77.5 234.7L82.3 235.5L81.7 228.3L84.8 227.7L87.5 225.5L89.9 226.8L96.6 223.8L97.2 225.8L94.3 228.0L92.9 233.0L91.0 235.5L92.1 238.1L94.5 236.0L93.9 230.1L98.7 232.1L96.8 238.2L97.3 244.6L100.5 240.1L98.6 235.6L100.5 234.9L102.8 235.9L106.0 234.6L109.0 235.3L107.3 233.1L105.4 233.8L103.6 233.0L103.5 230.7L108.8 228.0L110.5 230.0L111.3 229.4L109.0 226.6L101.8 226.1L101.2 220.1L97.2 214.9L98.0 211.9L101.4 209.1L102.0 206.3L105.1 203.2L106.9 204.7L110.0 204.9L123.5 201.1L123.8 202.6L127.5 201.8L132.8 203.8L133.8 208.5L131.8 210.0L135.1 212.1L134.5 214.4L136.3 216.7L139.2 216.2L140.1 224.9L135.0 237.5L136.5 235.1L141.8 239.2L136.7 234.8L140.6 225.0L147.0 227.2L140.7 224.5L139.8 216.0L142.1 214.9L142.1 209.9L143.2 208.6L143.0 206.8L139.7 205.8L141.7 204.9L142.2 202.8L139.9 203.3L139.4 200.1L138.1 200.9L134.6 198.4L139.4 194.6L141.1 188.4Z",
  "M463.0 249.2L462.0 246.0L461.6 250.1L458.1 247.1L457.0 247.4L460.1 251.2L456.2 252.6L462.4 253.2L463.9 257.5L463.6 260.0L459.6 259.7L457.8 258.2L457.7 255.9L454.8 258.7L450.9 257.1L449.0 257.8L447.0 253.7L448.0 252.2L446.5 252.3L445.2 250.4L447.1 258.1L445.7 260.6L443.8 260.9L439.0 259.1L437.3 253.9L437.5 249.4L435.1 259.1L425.2 251.3L425.5 249.6L424.6 250.9L422.5 250.9L419.4 249.4L416.9 246.1L417.4 249.9L426.8 255.0L430.1 259.1L422.7 263.8L426.7 261.7L434.0 262.5L433.6 265.3L431.6 266.1L432.8 267.9L431.9 270.6L433.4 267.1L436.4 264.3L441.5 265.2L441.2 268.5L438.3 274.4L442.3 268.9L444.9 268.9L443.5 267.5L445.6 267.7L444.1 265.6L446.1 263.9L450.2 263.2L451.5 265.2L452.1 262.9L455.6 262.3L460.8 264.9L464.0 268.1L463.6 264.9L467.3 265.1L467.7 268.6L469.5 266.7L472.4 266.4L476.2 263.9L474.7 261.6L478.4 259.2L473.9 258.7L470.2 252.6L472.2 257.2L471.6 259.3L470.6 260.4L468.7 259.0L467.0 259.7L465.8 256.8L467.1 254.2L465.3 254.4L463.9 251.6L464.9 249.7L467.3 249.8L464.8 247.2L463.0 249.2Z",
  "M440.8 196.1L438.8 195.6L436.3 191.5L439.7 198.3L439.6 200.3L437.7 201.9L436.0 199.6L435.3 201.6L433.3 201.8L430.8 200.6L431.8 197.5L430.2 198.3L428.5 195.8L429.9 198.9L430.2 205.3L434.8 204.8L437.4 205.8L436.3 211.2L434.1 213.4L437.7 211.2L438.0 208.7L440.1 207.4L445.9 210.0L444.5 213.6L441.3 214.7L441.6 216.1L439.6 218.3L436.4 219.2L440.7 219.6L441.7 221.4L443.5 217.3L450.0 212.7L448.5 219.4L453.0 214.1L454.0 215.2L460.9 214.8L454.4 214.4L456.8 208.3L452.6 205.3L453.1 201.6L454.6 200.8L452.9 200.8L453.1 198.3L451.4 199.5L449.8 198.5L451.4 200.8L451.1 203.7L449.3 203.9L447.2 201.2L448.0 204.8L446.5 205.5L444.2 204.8L441.1 200.9L441.4 196.8L444.0 196.1L443.1 192.7L440.8 196.1Z",
  "M284.4 315.3L272.1 313.2L269.9 317.9L268.7 327.8L285.2 344.4L289.2 346.3L294.0 346.0L298.7 341.1L298.1 338.3L296.4 337.2L290.8 338.9L289.0 338.4L288.3 336.8L291.5 331.3L292.0 326.3L295.7 318.3L294.6 317.1L284.4 315.3Z",
  "M663.7 139.1L659.4 137.6L658.0 139.1L660.7 140.8L660.8 144.1L663.4 146.2L659.2 149.6L660.5 150.7L671.3 145.9L671.3 143.4L669.5 142.5L668.0 139.5L663.7 139.1Z",
  "M252.4 331.4L253.3 328.2L249.3 327.4L248.2 331.4L243.9 330.6L242.7 331.4L248.0 331.8L244.8 339.8L249.7 341.9L253.2 353.1L256.9 350.5L254.7 343.2L258.5 343.7L254.8 342.9L256.0 340.4L253.8 340.2L252.4 331.4Z",
  "M266.8 147.5L265.6 146.9L265.3 144.6L267.3 142.5L264.6 142.3L262.8 140.5L262.4 138.0L257.6 130.0L257.5 126.6L253.0 140.3L255.8 139.1L260.1 147.3L262.4 149.5L266.2 160.9L265.4 165.5L266.8 165.8L268.0 160.3L272.1 156.4L270.4 154.5L268.6 149.0L266.0 148.4L266.8 147.5Z",
  "M252.1 142.4L257.4 126.9L259.4 124.9L248.6 126.7L250.2 129.3L250.0 133.1L248.8 136.3L246.2 138.4L247.0 141.3L244.3 143.6L245.5 146.5L242.5 149.1L238.6 149.6L238.8 151.6L239.8 152.0L244.1 150.4L246.0 151.3L245.1 156.4L235.0 162.1L227.4 154.7L226.6 155.4L233.2 162.7L228.6 163.8L224.3 168.1L222.6 171.4L224.0 171.3L229.9 164.6L236.4 163.6L236.8 178.7L235.4 185.5L228.6 190.5L225.9 200.9L229.6 189.7L235.6 187.0L237.4 183.1L239.0 162.5L240.8 161.2L246.4 161.0L251.2 154.8L250.6 145.0L252.1 142.4Z",
  "M546.2 344.4L544.9 345.2L545.8 347.5L544.8 350.4L538.6 357.2L538.0 365.6L540.0 365.3L539.4 360.2L540.5 357.1L547.9 357.7L551.5 356.7L550.2 355.5L552.1 355.5L552.9 357.1L554.5 356.9L553.6 355.7L554.9 356.5L556.2 354.7L552.7 350.8L551.9 345.4L546.2 344.4Z"
];

export const LRT_PATHS: string[] = [
  "M451.9 435.9L451.6 442.7L450.4 443.6L448.2 444.1L446.5 446.0",
  "M446.2 446.5L443.3 449.1",
  "M441.9 451.4L440.2 454.0",
  "M442.9 449.6L441.9 451.4",
  "M451.9 435.9L452.1 426.5L451.7 426.1L449.3 426.1",
  "M621.0 171.8L618.1 174.2L616.2 177.0",
  "M616.2 177.0L614.9 179.3",
  "M569.4 162.9L573.0 163.9L580.3 168.4",
  "M559.3 152.5L560.0 162.2",
  "M588.5 152.5L596.8 154.2",
  "M621.7 170.8L623.4 169.1L624.0 167.7L623.7 166.1L622.4 164.6",
  "M561.4 164.3L562.7 164.8L568.2 163.0",
  "M586.5 172.4L585.6 172.0",
  "M587.0 172.7L586.5 172.4",
  "M586.5 172.4L585.8 171.8",
  "M571.9 150.6L587.3 152.6",
  "M597.8 154.7L598.0 154.8",
  "M598.0 154.8L602.4 156.1L603.0 157.0L602.8 158.1",
  "M602.8 158.1L602.7 158.2",
  "M598.0 154.8L603.3 155.9L604.2 155.5L605.1 154.0",
  "M605.1 154.0L608.0 148.7",
  "M588.5 152.7L595.9 154.1",
  "M595.9 154.1L596.7 154.4",
  "M561.3 164.3L562.7 164.9L568.2 163.2",
  "M597.9 154.5L598.0 154.6",
  "M598.0 154.6L602.7 155.9",
  "M602.7 155.9L603.4 157.0",
  "M603.4 157.0L603.4 157.1",
  "M603.3 157.3L603.4 157.1",
  "M603.3 157.4L603.3 157.3",
  "M601.8 160.5L603.3 157.4",
  "M601.6 160.9L601.8 160.5",
  "M605.0 180.5L609.6 184.4L612.1 185.2L613.4 184.3L614.4 180.3",
  "M559.5 152.5L560.0 162.1",
  "M587.8 173.3L587.0 172.7",
  "M581.3 169.0L585.8 171.8",
  "M585.8 171.8L587.9 173.1",
  "M587.9 173.1L589.6 173.9",
  "M590.6 174.2L596.4 174.2L597.6 172.3",
  "M581.2 169.1L585.6 172.0",
  "M585.6 172.0L587.8 173.3",
  "M587.8 173.3L589.5 174.1",
  "M587.3 152.4L571.9 150.4",
  "M607.9 148.7L606.8 150.7",
  "M606.8 150.7L605.1 153.8",
  "M605.1 153.8L605.0 153.9",
  "M605.0 153.9L604.4 155.2",
  "M604.4 155.2L603.1 155.7L598.0 154.6",
  "M604.4 155.2L604.4 155.2",
  "M616.0 133.7L617.7 130.5L619.0 129.9L627.1 135.2",
  "M636.5 142.2L643.3 147.1",
  "M617.0 132.3L618.2 131.2L619.9 131.1L627.0 135.4",
  "M610.2 122.8L607.0 128.8",
  "M643.3 158.3L641.2 161.1L640.1 161.7L638.7 161.5L636.4 159.7",
  "M607.2 128.9L610.3 122.9",
  "M616.0 133.7L619.5 127.4",
  "M622.9 111.4L620.8 110.6L619.1 110.6L614.7 113.5",
  "M606.4 129.8L604.3 135.2",
  "M623.4 120.6L620.4 126.1",
  "M600.9 162.4L603.2 157.4L604.0 156.6L610.6 157.8",
  "M601.1 162.5L602.1 159.7L604.1 156.6L605.3 156.5L610.5 158.0",
  "M570.7 150.4L561.0 149.5L559.9 150.1L559.6 151.4",
  "M605.2 180.3L609.6 184.3L612.1 185.1L613.4 184.2L614.2 180.2",
  "M621.8 171.0L624.1 167.7L623.8 166.2L622.6 164.5",
  "M621.7 163.8L617.9 160.9L611.6 158.4",
  "M580.2 168.5L573.0 164.0L569.4 163.1",
  "M570.8 150.3L560.8 149.4L559.7 150.0L559.4 151.4",
  "M587.0 172.7L587.9 173.1",
  "M621.8 163.7L618.0 160.9L611.6 158.2",
  "M635.5 158.8L629.1 153.5",
  "M609.0 141.8L610.3 142.8L610.4 144.2",
  "M610.4 144.2L607.9 148.7",
  "M628.0 152.9L622.6 148.4",
  "M609.0 141.8L603.8 139.7L603.4 138.6L603.9 136.5",
  "M636.6 142.1L643.4 147.0",
  "M628.1 135.9L635.7 141.4",
  "M643.1 158.2L641.2 160.9L640.1 161.6L638.7 161.4L636.5 159.6",
  "M628.0 136.1L635.5 141.5",
  "M623.3 120.5L620.2 126.0",
  "M612.1 141.5L612.3 141.1",
  "M611.9 141.8L612.1 141.5",
  "M611.0 143.4L611.9 141.8",
  "M608.0 148.7L611.0 143.4",
  "M644.5 147.7L647.2 149.8L647.7 151.4L644.0 157.3",
  "M623.0 111.3L620.7 110.5L619.1 110.5L614.6 113.4",
  "M619.5 127.4L618.1 130.1",
  "M618.1 130.1L617.5 131.1",
  "M617.5 131.1L616.1 133.7",
  "M610.9 121.8L613.9 114.4",
  "M623.9 119.4L626.0 114.8L625.5 113.1L624.0 112.0",
  "M628.1 152.7L622.7 148.3",
  "M635.4 158.9L629.0 153.6",
  "M604.5 135.3L606.6 129.9",
  "M643.8 157.2L647.7 151.4L647.1 149.8L644.4 147.9",
  "M624.0 119.5L626.1 114.8L625.6 113.1L624.0 111.8",
  "M613.8 114.3L610.7 121.7",
  "M612.4 141.0L612.3 141.1",
  "M613.6 138.4L612.1 141.3L610.3 142.2L603.9 139.8L603.4 138.6L603.9 136.5",
  "M621.6 147.7L612.2 142.6L611.9 141.2L613.6 138.1",
  "M621.7 147.5L612.4 142.6L612.1 141.2L613.7 138.2",
  "M613.5 138.3L611.5 141.4L610.2 141.8L604.1 139.6L603.6 138.5L604.1 136.5",
  "M616.2 133.8L619.6 127.5",
  "M289.6 187.7L296.7 190.8",
  "M597.5 173.3L597.9 174.3L600.8 175.9L604.4 179.5",
  "M597.5 173.3L600.0 165.8",
  "M597.4 173.0L597.8 174.3L600.8 176.0L604.2 179.7",
  "M597.4 173.0L599.8 165.7",
  "M287.8 178.7L286.9 185.8L289.0 187.3",
  "M307.1 195.0L310.7 193.9L315.3 191.1",
  "M297.5 191.2L306.3 195.0",
  "M297.5 191.2L306.3 195.0",
  "M316.1 190.9L321.2 189.3",
  "M287.7 178.8L286.8 185.8L288.9 187.4",
  "M316.1 190.8L319.9 189.4",
  "M289.6 187.6L296.7 190.8",
  "M307.1 195.0L310.7 193.9L315.3 191.1",
  "M321.6 189.1L322.3 190.6",
  "M322.3 190.6L322.3 190.6",
  "M590.6 174.4L596.3 174.3L597.5 173.3",
  "M597.5 173.3L598.5 169.8",
  "M321.2 189.3L323.2 192.5L324.1 192.9",
  "M321.4 189.3L322.3 190.6",
  "M322.3 190.6L323.3 192.4L324.0 192.8",
  "M560.1 162.3L560.3 162.7",
  "M560.0 162.3L560.3 162.7",
  "M316.1 190.8L321.0 189.1L323.5 192.6L325.5 192.5",
  "M321.3 188.7L321.6 189.1",
  "M319.9 189.4L320.1 189.2",
  "M614.8 179.1L616.2 177.0",
  "M614.8 179.2L617.3 174.9",
  "M617.3 174.9L620.9 171.6",
  "M328.9 174.6L325.1 178.0L324.3 180.6L324.5 182.2",
  "M339.3 171.8L335.5 169.9L333.8 169.8L332.2 170.6L329.4 173.9",
  "M324.9 182.9L328.6 190.4L328.4 191.7",
  "M328.4 191.7L326.6 192.4",
  "M339.3 171.7L335.5 169.9L333.7 169.8L332.2 170.6L329.4 173.9",
  "M324.8 182.9L328.6 190.4L328.2 191.8",
  "M328.2 191.8L326.5 192.3",
  "M324.1 192.9L325.5 192.6",
  "M324.0 192.8L325.5 192.5",
  "M342.5 178.4L343.8 175.4L342.6 173.7L340.4 172.4",
  "M342.5 178.4L343.8 175.5L342.5 173.7L340.4 172.4",
  "M328.8 174.6L325.1 178.0L324.2 180.6L324.5 182.2",
  "M346.0 187.7L346.2 185.3L345.6 184.4L340.0 184.3L339.2 183.9L339.5 181.6L341.9 179.1",
  "M346.0 187.7L346.1 185.2L345.2 184.4",
  "M345.2 184.4L340.0 184.4L339.2 184.0L339.4 181.7L341.8 179.0",
  "M333.9 192.9L341.1 197.4L342.1 197.4L342.8 196.6",
  "M343.4 195.6L345.7 191.4L346.0 188.5",
  "M343.4 195.7L345.7 191.4L346.0 188.5",
  "M333.9 193.0L341.1 197.5L342.1 197.5L342.8 196.6",
  "M326.5 192.3L330.7 191.5L333.3 192.5",
  "M326.6 192.4L330.7 191.6L333.3 192.6"
];

export const OFFICIAL_RAIL_STATIONS = [
  {
    "x": 727.8,
    "y": 311.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 278.4,
    "y": 189.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 212.6,
    "y": 251.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 214.6,
    "y": 301.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 283.5,
    "y": 271.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 283,
    "y": 285.9,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 606.9,
    "y": 129.3,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 610.6,
    "y": 122.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 463.9,
    "y": 57.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 264.7,
    "y": 235.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 608.2,
    "y": 224.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 761.2,
    "y": 204.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 533.4,
    "y": 208.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 720.6,
    "y": 264.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 370.7,
    "y": 367.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 437.4,
    "y": 375.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 375.7,
    "y": 70.8,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 459,
    "y": 382.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 373.6,
    "y": 46.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 390.3,
    "y": 91.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 484.1,
    "y": 393.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 298.5,
    "y": 212.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 475.4,
    "y": 294.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 474.3,
    "y": 223,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 614.3,
    "y": 113.8,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 604.8,
    "y": 180.1,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 614.6,
    "y": 179.9,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 623.4,
    "y": 111.5,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 580.8,
    "y": 168.8,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 559.5,
    "y": 152.1,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 635.8,
    "y": 159.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 590.2,
    "y": 174.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 446.3,
    "y": 446.3,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 472.4,
    "y": 378,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 622.1,
    "y": 147.9,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 611.2,
    "y": 158.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 636,
    "y": 141.7,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 568.7,
    "y": 163.1,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 628.7,
    "y": 153.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 604.2,
    "y": 136,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 644,
    "y": 147.5,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 597.4,
    "y": 154.5,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 621.3,
    "y": 171.4,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 642.8,
    "y": 156.2,
    "type": "INTERCHANGE",
    "interchange": true
  },
  {
    "x": 560.6,
    "y": 163.1,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 571.4,
    "y": 150.4,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 627.5,
    "y": 135.6,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 623.6,
    "y": 120.1,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 622.2,
    "y": 164.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 588,
    "y": 152.6,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 190.1,
    "y": 276,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 289.3,
    "y": 187.5,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 315.7,
    "y": 191,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 297,
    "y": 190.9,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 287.4,
    "y": 177.7,
    "type": "INTERCHANGE",
    "interchange": true
  },
  {
    "x": 306.8,
    "y": 195.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 343.1,
    "y": 196.2,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 339.8,
    "y": 172.1,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 329.1,
    "y": 174.3,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 342.1,
    "y": 178.8,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 324.7,
    "y": 182.6,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 443.1,
    "y": 449.4,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 440,
    "y": 454.3,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 478.8,
    "y": 409.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 288.6,
    "y": 311,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 434.8,
    "y": 307.8,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 580.9,
    "y": 358.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 588.8,
    "y": 299.5,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 575.1,
    "y": 298.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 422.8,
    "y": 414.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 530,
    "y": 314.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 382.3,
    "y": 339.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 533.1,
    "y": 325.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 329.7,
    "y": 210.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 335.1,
    "y": 224.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 525.3,
    "y": 391.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 397,
    "y": 290.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 614.9,
    "y": 135.8,
    "type": "INTERCHANGE",
    "interchange": true
  },
  {
    "x": 600.3,
    "y": 164.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 554.3,
    "y": 250.2,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 592.8,
    "y": 206.4,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 456.1,
    "y": 312.1,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 574.8,
    "y": 319.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 738.1,
    "y": 281.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 418.2,
    "y": 300.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 470.3,
    "y": 240.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 594.8,
    "y": 317,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 468.9,
    "y": 347,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 497.6,
    "y": 355.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 507.6,
    "y": 360.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 505,
    "y": 339.2,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 518,
    "y": 342.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 512.1,
    "y": 345.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 506.8,
    "y": 209.7,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 595.7,
    "y": 182.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 600.3,
    "y": 164.6,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 535.5,
    "y": 247,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 579,
    "y": 229.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 585.2,
    "y": 280.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 701.3,
    "y": 241.7,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 706.9,
    "y": 297.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 636.7,
    "y": 310.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 573.6,
    "y": 341,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 500.2,
    "y": 285.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 499.7,
    "y": 270.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 249.5,
    "y": 233.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 376.8,
    "y": 354.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 734.7,
    "y": 214.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 492.7,
    "y": 218.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 555.8,
    "y": 207.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 471.3,
    "y": 365.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 315.6,
    "y": 332,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 471.1,
    "y": 110.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 485.2,
    "y": 276,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 826,
    "y": 209,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 533,
    "y": 338.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 712.1,
    "y": 204.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 503.8,
    "y": 248.1,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 690.6,
    "y": 181.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 346,
    "y": 188,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 368,
    "y": 281.3,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 354.5,
    "y": 295.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 333.6,
    "y": 192.8,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 550.6,
    "y": 330.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 793,
    "y": 235,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 439.7,
    "y": 150.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 549.5,
    "y": 272.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 277.9,
    "y": 297.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 201.7,
    "y": 258.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 191.3,
    "y": 253.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 213.2,
    "y": 286,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 216.4,
    "y": 315.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 217,
    "y": 326.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 178.7,
    "y": 249,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 167.8,
    "y": 242.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 157.2,
    "y": 252.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 151,
    "y": 264.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 277.4,
    "y": 259.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 289.2,
    "y": 299.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 545.4,
    "y": 372.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 586.1,
    "y": 336.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 744.1,
    "y": 293.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 677.3,
    "y": 278.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 647.9,
    "y": 282.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 627.9,
    "y": 281.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 352.4,
    "y": 269.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 608.5,
    "y": 291.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 551.3,
    "y": 309.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 506.9,
    "y": 356.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 494.4,
    "y": 369.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 70.1,
    "y": 291.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 64.8,
    "y": 268.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 89.7,
    "y": 310.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 113.4,
    "y": 313.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 711.6,
    "y": 319.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 331.2,
    "y": 321.5,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 325.2,
    "y": 191.8,
    "type": "INTERCHANGE",
    "interchange": true
  },
  {
    "x": 724.2,
    "y": 237.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 532.9,
    "y": 413.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 604.6,
    "y": 354.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 621.2,
    "y": 348.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 672.3,
    "y": 333.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 465,
    "y": 415.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 500.1,
    "y": 409.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 641,
    "y": 340,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 555.1,
    "y": 359.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 737.2,
    "y": 267.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 696.4,
    "y": 327.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 495.5,
    "y": 184.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 442.7,
    "y": 339.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 415.2,
    "y": 365.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 365.1,
    "y": 390.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 206.6,
    "y": 274.3,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 384.6,
    "y": 403.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 616.6,
    "y": 312.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 338.6,
    "y": 241,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 479.1,
    "y": 203.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 358.5,
    "y": 330.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 257.5,
    "y": 216.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 478.3,
    "y": 178.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 493.5,
    "y": 394,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 507.7,
    "y": 400.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 516.5,
    "y": 403.8,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 533,
    "y": 408.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 544.9,
    "y": 394.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 484.5,
    "y": 253,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 502.8,
    "y": 390.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 493.7,
    "y": 385.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 689.6,
    "y": 259.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 567.6,
    "y": 264.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 545.8,
    "y": 288.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 466.3,
    "y": 284,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 493.2,
    "y": 311.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 558.7,
    "y": 347.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 534.5,
    "y": 354.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 514.8,
    "y": 328.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 394.8,
    "y": 329.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 399.2,
    "y": 348.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 418.4,
    "y": 317.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 409.1,
    "y": 411.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 447,
    "y": 425.7,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 150.4,
    "y": 296.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 239.2,
    "y": 262,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 297.9,
    "y": 252.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 293.8,
    "y": 151.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 302.9,
    "y": 232.9,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 263.2,
    "y": 266.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 672.5,
    "y": 304.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 451.8,
    "y": 347.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 499.1,
    "y": 402,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 509.2,
    "y": 388.3,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 619.9,
    "y": 126.9,
    "type": "LRT",
    "interchange": false
  },
  {
    "x": 323.6,
    "y": 94.6,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 348.9,
    "y": 79.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 404.4,
    "y": 62.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 445.1,
    "y": 44.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 511.8,
    "y": 368.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 519,
    "y": 353.6,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 483.7,
    "y": 353.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 498.9,
    "y": 378.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 518.1,
    "y": 367.7,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 512.1,
    "y": 396.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 528.6,
    "y": 368.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 271.6,
    "y": 245.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 224,
    "y": 244.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 631,
    "y": 115.8,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 391.2,
    "y": 269,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 481.4,
    "y": 327.2,
    "type": "MRT",
    "interchange": true
  },
  {
    "x": 688.5,
    "y": 210.4,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 475.3,
    "y": 85.2,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 306.2,
    "y": 145.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 297.1,
    "y": 119.5,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 296.6,
    "y": 119.1,
    "type": "MRT",
    "interchange": false
  },
  {
    "x": 799.1,
    "y": 303.4,
    "type": "MRT",
    "interchange": false
  }
] as const;
